import { ConfluenceOverlayTemplate } from "@/components/signup/layouts/product-overlay-template";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";
import { useIsConfluenceContactCompanyExpandEligible } from "@/components/user-context/helpers/cohorts";
import { FeatureExposed } from "@/utils/feature-exposed/use-feature-exposed";

import { Headings } from "../../../components/headings";
import { FreeForTenUsersText } from "../../../components/sub-heading";
import { WelcomeBackText } from "../../../components/welcome-back-heading";

export const ExistingUser = () => {
    const useContactExpandCohortLogic =
        useIsConfluenceContactCompanyExpandEligible();

    return (
        <FeatureExposed
            experimentKey="cfind-3467-signup-with-image-overlay"
            group="isTreatment"
        >
            <ConfluenceOverlayTemplate size="sm">
                <Headings
                    main={<WelcomeBackText />}
                    sub={<FreeForTenUsersText />}
                />
                <SiteActivation
                    useContactExpandCohortLogic={useContactExpandCohortLogic}
                />
            </ConfluenceOverlayTemplate>
        </FeatureExposed>
    );
};
